import { defineStore, acceptHMRUpdate } from 'pinia';

type Theme = 'light' | 'dark';

const storageKey = 'neo-flex-ui-theme';

function saveTheme(theme: Theme) {
  if (!localStorage) return;

  document.querySelector('html')?.setAttribute('data-theme', theme);
  localStorage.setItem(storageKey, theme);
}

/** 로컬 스토리지에 저장된 테마값을 읽어보고, 없으면 시스템 설정의 테마로 설정 */
function loadTheme() {
  if (!localStorage) return 'light';

  let systemTheme: Theme = 'light';
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    systemTheme = 'dark';
  }

  const storedTheme = localStorage.getItem(storageKey) as Theme;
  const theme = storedTheme || systemTheme;
  document.querySelector('html')?.setAttribute('data-theme', theme);

  return theme;
}

interface State {
  theme: Theme;
}

export const useThemeStore = defineStore('theme-store', {
  state: (): State => {
    return {
      theme: loadTheme(),
    };
  },
  getters: {
    isLight: (state) => {
      return state.theme === 'light';
    },
    isDark: (state) => {
      return state.theme === 'dark';
    },
  },
  actions: {
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light';
      saveTheme(this.theme);
    },
    setTheme(val: Theme) {
      this.theme = val;
      saveTheme(this.theme);
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useThemeStore, import.meta.hot));
}
